module.exports = __webpack_public_path__ + "static/media/background.8689ea37.svg";